import { REGISTERED_CLICKSTREAM_EVENTS, RegisteredClickstreamEvents } from '../events/registeredEvents';

// by requirement from Clickstream, an impression or view event will always be "view_content"
export const SEMANTIC_VIEW_EVENT = 'view_content';

/**
 * These are defined in the Event Registry and should not be changed without a corresponding configuration change
 */
export const SEMANTIC_EVENTS: Record<RegisteredClickstreamEvents, string> = {
    [REGISTERED_CLICKSTREAM_EVENTS.CALLBACK_SCHEDULER_APPOINTMENT_BOOKER_LOADED]: SEMANTIC_VIEW_EVENT,
    [REGISTERED_CLICKSTREAM_EVENTS.CALLBACK_SCHEDULER_APPOINTMENT_CONFIRMED]: SEMANTIC_VIEW_EVENT,
    [REGISTERED_CLICKSTREAM_EVENTS.CALLBACK_SCHEDULER_APPOINTMENT_FAILED]: SEMANTIC_VIEW_EVENT,
    [REGISTERED_CLICKSTREAM_EVENTS.CALLBACK_SCHEDULER_BOOK_APPOINTMENT_CLICK]: 'zhl_callback_scheduler_submit',
    [REGISTERED_CLICKSTREAM_EVENTS.CALLBACK_SCHEDULER_FAILURE_DASHBOARD_BUTTON_CLICK]:
        'zhl_callback_scheduler_dashboard_button',
    [REGISTERED_CLICKSTREAM_EVENTS.CALLBACK_SCHEDULER_SUCCESS_DASHBOARD_BUTTON_CLICK]:
        'zhl_callback_scheduler_preapproval_button',
    [REGISTERED_CLICKSTREAM_EVENTS.CALLBACK_SCHEDULER_EXIT_CLICK]: 'zhl_close_scheduler_button',
    [REGISTERED_CLICKSTREAM_EVENTS.UNIVERSAL_CALL_ZHL]: 'zhl_call',
    [REGISTERED_CLICKSTREAM_EVENTS.UNIVERSAL_CLOSE_ABAD_ON_ZHL]: 'abad_close',
    [REGISTERED_CLICKSTREAM_EVENTS.UNIVERSAL_VIEW_ABAD_ON_ZHL]: SEMANTIC_VIEW_EVENT,
    [REGISTERED_CLICKSTREAM_EVENTS.UNIVERSAL_START_ZHL_FUNNEL]: 'zhl_start',
    [REGISTERED_CLICKSTREAM_EVENTS.UNIVERSAL_START_ZHL_REFINANCE_FUNNEL]: 'zhl_start',
    [REGISTERED_CLICKSTREAM_EVENTS.UNIVERSAL_START_ZHL_PURCHASE_FUNNEL]: 'zhl_start',
    [REGISTERED_CLICKSTREAM_EVENTS.UNIVERSAL_START_PREQUAL_BUTTON_CLICK]: 'zhl_prequal_lead_start',
    [REGISTERED_CLICKSTREAM_EVENTS.PRIMARY_CTA_CLICK]: 'home_loans_dashboard_beth_upsell_module_primary_cta_click',
    [REGISTERED_CLICKSTREAM_EVENTS.SECONDARY_CTA_CLICK]: 'home_loans_dashboard_beth_upsell_module_secondary_cta_click',
    [REGISTERED_CLICKSTREAM_EVENTS.RESOURCE_CARD_PRIMARY_CTA_CLICK]:
        'home_loans_dashboard_beth_resource_card_primary_cta_click',
    [REGISTERED_CLICKSTREAM_EVENTS.RESOURCE_CARD_MODAL_BACKDROP_CLICK]:
        'home_loans_dashboard_beth_resource_card_modal_backdrop_click',
    [REGISTERED_CLICKSTREAM_EVENTS.RESOURCE_CARD_MODAL_CLOSE_CLICK]:
        'home_loans_dashboard_beth_resouce_card_modal_close_click',
    [REGISTERED_CLICKSTREAM_EVENTS.RESOURCE_CARD_MODAL_PRIMARY_CTA_CLICK]:
        'home_loans_dashboard_beth_resource_card_modal_primary_cta_click',
    [REGISTERED_CLICKSTREAM_EVENTS.TEAM_INFORMATION_CARD_CALL_CTA_CLICK]:
        'home_loans_dashboard_beth_team_information_card_call_cta_click',
    [REGISTERED_CLICKSTREAM_EVENTS.TEAM_INFORMATION_CARD_CALL_OR_TEXT_CTA_CLICK]:
        'home_loans_dashboard_beth_team_information_card_call_or_text_cta_click',
    [REGISTERED_CLICKSTREAM_EVENTS.TEAM_INFORMATION_CARD_EMAIL_CTA_CLICK]:
        'home_loans_dashboard_beth_team_information_card_email_cta_click',
    [REGISTERED_CLICKSTREAM_EVENTS.SAVED_INFORMATION_PRIMARY_CTA_CLICK]:
        'home_loans_dashboard_beth_view_saved_information_card_primary_cta_click',
    [REGISTERED_CLICKSTREAM_EVENTS.UPSELL_MODULE_LOADED]: SEMANTIC_VIEW_EVENT,
    [REGISTERED_CLICKSTREAM_EVENTS.RESOURCE_CARD_MODULE_LOADED]: SEMANTIC_VIEW_EVENT,
    [REGISTERED_CLICKSTREAM_EVENTS.TEAM_INFORMATION_CARD_MODULE_LOADED]: SEMANTIC_VIEW_EVENT,
    [REGISTERED_CLICKSTREAM_EVENTS.VIEW_SAVED_INFORMATION_CARD_MODULE_LOADED]: SEMANTIC_VIEW_EVENT,
    [REGISTERED_CLICKSTREAM_EVENTS.REDIRECT_TO_GOLDENEYE]: SEMANTIC_VIEW_EVENT,
    [REGISTERED_CLICKSTREAM_EVENTS.REDIRECT_TO_DASHBOARD]: SEMANTIC_VIEW_EVENT,
    [REGISTERED_CLICKSTREAM_EVENTS.DASHBOARD_LOADED]: 'home_loans_dashboard_loaded',
    [REGISTERED_CLICKSTREAM_EVENTS.DASHBOARD_BOUNCE_LOADED]: 'home_loans_dashboard_bounce_page_loaded',
};

export const SEMANTIC_TAGS: Record<RegisteredClickstreamEvents, string[]> = {
    [REGISTERED_CLICKSTREAM_EVENTS.CALLBACK_SCHEDULER_BOOK_APPOINTMENT_CLICK]: ['zhl_callback_scheduler'],
    [REGISTERED_CLICKSTREAM_EVENTS.CALLBACK_SCHEDULER_EXIT_CLICK]: ['zhl_callback_scheduler'],
    [REGISTERED_CLICKSTREAM_EVENTS.CALLBACK_SCHEDULER_APPOINTMENT_BOOKER_LOADED]: ['zhl_callback_scheduler'],
    [REGISTERED_CLICKSTREAM_EVENTS.CALLBACK_SCHEDULER_SUCCESS_DASHBOARD_BUTTON_CLICK]: ['zhl_callback_scheduler'],
    [REGISTERED_CLICKSTREAM_EVENTS.CALLBACK_SCHEDULER_FAILURE_DASHBOARD_BUTTON_CLICK]: ['zhl_callback_scheduler'],
    [REGISTERED_CLICKSTREAM_EVENTS.CALLBACK_SCHEDULER_APPOINTMENT_CONFIRMED]: ['zhl_callback_scheduler'],
    [REGISTERED_CLICKSTREAM_EVENTS.CALLBACK_SCHEDULER_APPOINTMENT_FAILED]: ['zhl_callback_scheduler'],
    [REGISTERED_CLICKSTREAM_EVENTS.UNIVERSAL_CALL_ZHL]: [],
    [REGISTERED_CLICKSTREAM_EVENTS.UNIVERSAL_CLOSE_ABAD_ON_ZHL]: [],
    [REGISTERED_CLICKSTREAM_EVENTS.UNIVERSAL_VIEW_ABAD_ON_ZHL]: [],
    [REGISTERED_CLICKSTREAM_EVENTS.UNIVERSAL_START_ZHL_FUNNEL]: [],
    [REGISTERED_CLICKSTREAM_EVENTS.UNIVERSAL_START_ZHL_REFINANCE_FUNNEL]: [],
    [REGISTERED_CLICKSTREAM_EVENTS.UNIVERSAL_START_ZHL_PURCHASE_FUNNEL]: [],
    [REGISTERED_CLICKSTREAM_EVENTS.UNIVERSAL_START_PREQUAL_BUTTON_CLICK]: [],
    [REGISTERED_CLICKSTREAM_EVENTS.PRIMARY_CTA_CLICK]: [],
    [REGISTERED_CLICKSTREAM_EVENTS.SECONDARY_CTA_CLICK]: [],
    [REGISTERED_CLICKSTREAM_EVENTS.RESOURCE_CARD_PRIMARY_CTA_CLICK]: [],
    [REGISTERED_CLICKSTREAM_EVENTS.RESOURCE_CARD_MODAL_BACKDROP_CLICK]: [],
    [REGISTERED_CLICKSTREAM_EVENTS.RESOURCE_CARD_MODAL_CLOSE_CLICK]: [],
    [REGISTERED_CLICKSTREAM_EVENTS.RESOURCE_CARD_MODAL_PRIMARY_CTA_CLICK]: [],
    [REGISTERED_CLICKSTREAM_EVENTS.TEAM_INFORMATION_CARD_CALL_CTA_CLICK]: [],
    [REGISTERED_CLICKSTREAM_EVENTS.TEAM_INFORMATION_CARD_CALL_OR_TEXT_CTA_CLICK]: [],
    [REGISTERED_CLICKSTREAM_EVENTS.TEAM_INFORMATION_CARD_EMAIL_CTA_CLICK]: [],
    [REGISTERED_CLICKSTREAM_EVENTS.SAVED_INFORMATION_PRIMARY_CTA_CLICK]: [],
    [REGISTERED_CLICKSTREAM_EVENTS.UPSELL_MODULE_LOADED]: [],
    [REGISTERED_CLICKSTREAM_EVENTS.RESOURCE_CARD_MODULE_LOADED]: [],
    [REGISTERED_CLICKSTREAM_EVENTS.TEAM_INFORMATION_CARD_MODULE_LOADED]: [],
    [REGISTERED_CLICKSTREAM_EVENTS.VIEW_SAVED_INFORMATION_CARD_MODULE_LOADED]: [],
    [REGISTERED_CLICKSTREAM_EVENTS.REDIRECT_TO_GOLDENEYE]: [],
    [REGISTERED_CLICKSTREAM_EVENTS.REDIRECT_TO_DASHBOARD]: [],
    [REGISTERED_CLICKSTREAM_EVENTS.DASHBOARD_LOADED]: [],
    [REGISTERED_CLICKSTREAM_EVENTS.DASHBOARD_BOUNCE_LOADED]: [],
};
